package com.eladfinish.bible.contest.screens.lexicographicalSort.usecases

import com.eladfinish.bible.contest.network.ApiBaseUrlProvider
import com.eladfinish.bible.contest.network.isNetworkConnectivityError
import com.eladfinish.contract.pdf.GeneratePdfFromHtmlRequest
import io.github.aakira.napier.Napier
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.timeout
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

/**
 * Renders [tableHtml] to PDF on the server (Gotenberg) and returns the raw bytes — used on
 * platforms with no local HTML-to-PDF API of their own (web has no print-to-PDF a browser
 * sandbox can call; see [com.eladfinish.bible.contest.screens.browse.usecases.GenerateHtmlToPdfUseCase]).
 */
interface GeneratePdfFromHtmlApiUseCase {
    suspend operator fun invoke(tableHtml: String, fileName: String): Result<ByteArray>
}

class GeneratePdfFromHtmlApiUseCaseImpl(
    private val httpClient: HttpClient,
    private val apiBaseUrlProvider: ApiBaseUrlProvider,
) : GeneratePdfFromHtmlApiUseCase {

    override suspend fun invoke(tableHtml: String, fileName: String): Result<ByteArray> {
        Napier.d(
            message = "generate_pdf_from_html: htmlSize=${tableHtml.length}",
            tag = "GeneratePdfFromHtmlApiUseCase",
        )

        return runCatching {
            httpClient.post(
                urlString = "${apiBaseUrlProvider.getBaseUrl()}/pdf/generate-from-html",
            ) {
                timeout {
                    requestTimeoutMillis = 180_000L
                    socketTimeoutMillis = 180_000L
                    connectTimeoutMillis = 10_000L
                }
                contentType(ContentType.Application.Json)
                setBody(GeneratePdfFromHtmlRequest(tableHtml = tableHtml, fileName = fileName))
            }.body<ByteArray>()
        }.onFailure { e ->
            if (e.isNetworkConnectivityError()) {
                Napier.w(message = "generate_pdf_from_html: no internet", throwable = e, tag = "GeneratePdfFromHtmlApiUseCase")
            } else {
                Napier.e(message = "generate_pdf_from_html: unexpected error", throwable = e, tag = "GeneratePdfFromHtmlApiUseCase")
            }
        }
    }
}
